/* ============================================================
   Orange Spot Noir — theme.js
   Vanilla ES2020, keine Abhängigkeiten (kein jQuery, kein Swiper).
   Läuft im Shopify-Theme (AJAX Cart API) und im Prototyp (OSN_MOCK).
   ============================================================ */
(function () {
  'use strict';

  const doc = document;
  const root = doc.documentElement;
  const $  = (s, c) => (c || doc).querySelector(s);
  const $$ = (s, c) => Array.from((c || doc).querySelectorAll(s));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer:fine)').matches;
  const MOCK = window.OSN_MOCK || null;
  /* v1.8: Sprache – R ist „/“ (Deutsch) oder „/en/“; Texte kommen aus window.OSN_I18N (layout/theme.liquid, Übersetzungsdateien),
     der zweite Wert von T() ist der deutsche Rückfalltext. */
  const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const LANG = (root.getAttribute('lang') || 'de').slice(0, 2);
  const I18N = window.OSN_I18N || {};
  const T = (k, fb, vars) => { let s = I18N[k] != null ? String(I18N[k]) : fb; if (vars) s = s.replace(/{(\w+)}/g, (m, v) => (v in vars ? vars[v] : m)); return s; };
  const routes = Object.assign({ cart: R + 'cart', add: R + 'cart/add.js', change: R + 'cart/change.js', get: R + 'cart.js', suggest: R + 'search/suggest.json' }, window.OSN_ROUTES || {});

  root.classList.add('js');
  if (CSS.supports && CSS.supports('animation-timeline: view()')) root.classList.add('sda');

  const money = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  /* ---------- Header: Zustand beim Scrollen ---------- */
  const head = $('.head');
  let ticking = false;
  function onScroll() {
    const y = window.scrollY || 0;
    if (head) head.classList.toggle('is-stuck', y > 24);
    ticking = false;
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- Hero-Spotlight (nur Maus) ---------- */
  const hero = $('.hero'), spot = $('.spotlight', hero || doc);
  if (hero && spot && fine && !reduced) {
    let tx = 50, ty = 50, cx = 50, cy = 50, raf = null;
    const follow = () => {
      cx += (tx - cx) * 0.09; cy += (ty - cy) * 0.09;
      spot.style.setProperty('--mx', cx.toFixed(2) + '%'); spot.style.setProperty('--my', cy.toFixed(2) + '%');
      raf = (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) ? requestAnimationFrame(follow) : null;
    };
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width) * 100; ty = ((e.clientY - r.top) / r.height) * 100;
      if (!raf) raf = requestAnimationFrame(follow);
    });
  }

  /* ---------- Reveal-Fallback ohne Scroll-Driven Animations ---------- */
  function observeReveals(scope) {
    if (root.classList.contains('sda') || reduced) { $$('[data-reveal]', scope).forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]', scope).forEach((el) => io.observe(el));
  }
  observeReveals(doc);

  /* ---------- Vier Welten: Touch-Verhalten ---------- */
  $$('.worlds').forEach((worlds) => {
    if (fine) return;
    worlds.addEventListener('click', (e) => {
      const world = e.target.closest('.world');
      if (!world || matchMedia('(max-width: 900px)').matches) return;
      if (!world.classList.contains('is-open')) {
        e.preventDefault();
        $$('.world.is-open', worlds).forEach((w) => w.classList.remove('is-open'));
        world.classList.add('is-open');
      }
    });
  });

  /* ---------- Tabs ---------- */
  $$('[role="tablist"]').forEach((list) => {
    const tabs = $$('[role="tab"]', list);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = doc.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; if (on) { panel.style.animation = 'none'; void panel.offsetWidth; panel.style.animation = ''; initRails(panel); } }
      });
    };
    list.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) { select(t); setTimeout(() => $$('.rail-wrap').forEach((w) => updateRail(w)), 60); } });
    list.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(doc.activeElement); if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus(); select(n);
      }
    });
  });

  /* ---------- Rails (Scroll-Snap + Buttons + Fortschritt) ---------- */
  // Die Pfeile sitzen meist im Abschnittskopf, nicht in .rail-wrap: erst innen suchen, dann im umschließenden Abschnitt
  function railBtns(wrap) {
    let prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
    if (!prev && !next) {
      const scope = wrap.closest('.subcats, .added__recs, .tabpanel, section, dialog') || wrap.parentElement;
      if (scope) { prev = $('[data-rail-prev]', scope); next = $('[data-rail-next]', scope); }
    }
    return { prev, next };
  }
  function initRails(scope) {
    $$('.rail-wrap', scope).forEach((wrap) => {
      if (wrap.dataset.railInit) { updateRail(wrap); return; }
      wrap.dataset.railInit = '1';
      const rail = $('.rail', wrap); if (!rail) return;
      const { prev, next } = railBtns(wrap);
      const step = () => Math.max(rail.clientWidth * 0.8, 240);
      prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      rail.addEventListener('scroll', () => requestAnimationFrame(() => updateRail(wrap)), { passive: true });
      addEventListener('resize', () => updateRail(wrap));
      updateRail(wrap);
    });
  }
  function updateRail(wrap) {
    const rail = $('.rail', wrap); if (!rail) return;
    const max = rail.scrollWidth - rail.clientWidth;
    const p = max > 0 ? rail.scrollLeft / max : 0;
    const { prev, next } = railBtns(wrap);
    if (prev) prev.disabled = rail.scrollLeft < 4;
    if (next) next.disabled = rail.scrollLeft > max - 4;
    const bar = $('.rail__progress i', wrap);
    if (bar) {
      const w = max > 0 ? Math.max(0.12, rail.clientWidth / rail.scrollWidth) : 1;
      bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
      bar.style.setProperty('--x', (p * (1 / w - 1) * 100).toFixed(2) + '%');
    }
  }
  initRails(doc);

  /* ---------- Mobile-Navigation ---------- */
  const mnav = $('#mnav');
  const burgers = $$('[data-mnav-toggle]');
  function setMnav(open) {
    if (!mnav) return;
    mnav.classList.toggle('is-open', open);
    mnav.setAttribute('aria-hidden', String(!open));
    burgers.forEach((b) => { b.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open)); });
    doc.body.style.overflow = open ? 'hidden' : '';
  }
  burgers.forEach((b) => b.addEventListener('click', () => setMnav(!mnav.classList.contains('is-open'))));
  // Anker-Link auf derselben Seite (z. B. /#arcade): Menü zuklappen, sonst bleibt das Overlay über dem Ziel
  mnav && mnav.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]'); if (!a) return;
    try { if (new URL(a.href, location.href).pathname === location.pathname) setMnav(false); } catch (x) { /* egal */ }
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') setMnav(false); });

  /* ---------- Dialoge (Suche, Cart, Filter) ---------- */
  function openDialog(id) {
    const d = doc.getElementById(id); if (!d || d.open) return;
    d.showModal();
    doc.body.style.overflow = 'hidden';
    d.addEventListener('close', () => { doc.body.style.overflow = ''; }, { once: true });
    const focus = $('[autofocus], input, button', d); focus && focus.focus();
  }
  doc.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog(opener.dataset.open); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { const d = closer.closest('dialog'); d && d.close(); return; }
    const d = e.target.closest('dialog');
    if (d && e.target === d && !d.hasAttribute('data-modal-strict')) d.close(); /* Klick auf Backdrop */
  });

  /* ---------- Altersprüfung (Selbstauskunft 18+) ---------- */
  const gate = $('#age-gate');
  if (gate) {
    const KEY = 'osn_age_ok', days = Number(gate.dataset.days) || 30;
    let ok = false;
    try { const until = Number(localStorage.getItem(KEY) || 0); ok = until > Date.now(); } catch (e) {}
    if (!ok) {
      gate.showModal();
      doc.body.style.overflow = 'hidden';
      gate.addEventListener('cancel', (e) => e.preventDefault());
      $('[data-age-yes]', gate).addEventListener('click', () => {
        try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {}
        gate.close(); doc.body.style.overflow = '';
      });
    }
  }

  /* ---------- Suche (Predictive) ---------- */
  // „duenger“ → „Dünger“, „belueftung“ → „Belüftung“: Shopify sucht nicht über Umschreibungen hinweg
  const umlaut = (s) => s.replace(/ae/g, 'ä').replace(/oe/g, 'ö').replace(/ue/g, 'ü').replace(/Ae/g, 'Ä').replace(/Oe/g, 'Ö').replace(/Ue/g, 'Ü').replace(/ss/g, 'ß');
  const searchInput = $('#search-input'), searchResults = $('#search-results');
  if (searchInput && searchResults) {
    let t = null, ctrl = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        let products = [], cols = [];
        try {
          if (MOCK) products = MOCK.search(q);
          else {
            /* v1.92: Produkte und Kategorien; kompakte Zeilen statt Vollbild-Karten (Handy) */
            const suggest = async (term) => { const r = await fetch(`${routes.suggest}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last`, { signal: ctrl.signal }); const j = await r.json(); return j.resources.results || {}; };
            let res = await suggest(q);
            const alt = umlaut(q);
            if (!(res.products || []).length && alt !== q) res = await suggest(alt);
            cols = (res.collections || []).slice(0, 5).map((c) => ({ title: c.title, url: c.url }));
            products = (res.products || []).map((p) => ({ title: p.title, url: p.url, image: p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=160' : null, vendor: p.vendor, price: p.price }));
          }
        } catch (err) { if (err.name === 'AbortError') return; console.warn(err); }
        const qe = escapeHtml(q), allUrl = `${R}search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
        const priceTxt = (p) => (p.price ? (typeof p.price === 'number' ? money(p.price) : money(Math.round(parseFloat(String(p.price).replace(',', '.')) * 100))) : '');
        if (!products.length && !cols.length) {
          const tpl = $('[data-search-empty]');
          searchResults.innerHTML = `<p class="body srch__none">${T('search_none', 'Keine Treffer für „{q}“.', { q: qe })}</p>${tpl ? tpl.innerHTML : ''}`;
          return;
        }
        searchResults.innerHTML = `<div class="srch">${cols.length ? `<div class="srch__cats"><span class="srch__k">${escapeHtml(T('search_cats', 'Kategorien'))}</span>${cols.map((c) => `<a class="tag" href="${escapeHtml(c.url)}">${escapeHtml(c.title)}</a>`).join('')}</div>` : ''}${products.length ? `<div class="srch__list">${products.map((p) => `<a class="srow" href="${escapeHtml(p.url)}"><span class="srow__img">${p.image ? `<img src="${escapeHtml(p.image)}" alt="" loading="lazy" width="160" height="160">` : ''}</span><span class="srow__txt"><span class="srow__v">${escapeHtml(p.vendor || '')}</span><span class="srow__t">${escapeHtml(p.title)}</span></span><span class="srow__p">${escapeHtml(priceTxt(p))}</span></a>`).join('')}</div>` : ''}<a class="lnk srch__all" href="${escapeHtml(allUrl)}">${escapeHtml(T('search_all', 'Alle Ergebnisse für „{q}“', { q }))} <i class="arr"></i></a></div>`;
      }, 180);
    });
  }

  /* ---------- Toast ---------- */
  let toastEl = $('.toast');
  if (!toastEl) { toastEl = doc.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); doc.body.appendChild(toastEl); }
  let toastT = null;
  function toast(msg) {
    toastEl.innerHTML = `<i></i>${escapeHtml(msg)}`;
    toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  /* ---------- Warenkorb ---------- */
  const cartDrawer = $('#cart-drawer');
  const cartCount = $$('[data-cart-count]');

  async function cartRequest(url, body) {
    if (MOCK) return MOCK.cart(url, body);
    /* v1.51: cache 'no-store' – bei „Zurück“ lieferte der Browser /cart.js sonst aus dem Zwischenspeicher (alter Stand). */
    const r = await fetch(url, { method: body ? 'POST' : 'GET', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || e.message || T('error', 'Fehler')); }
    return r.json();
  }

  // Versandbalken serverseitig neu rendern: die Rechnung (Erde ausgenommen) liegt im Liquid der Section cart-ship (v1.21)
  let shipReq = 0;
  async function refreshShip() {
    const wrap = cartDrawer && $('[data-cart-ship-wrap]', cartDrawer);
    if (!wrap || MOCK) return;
    const n = ++shipReq;
    try {
      const r = await fetch(R + '?sections=cart-ship', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const j = await r.json();
      if (n === shipReq && j && j['cart-ship']) wrap.innerHTML = j['cart-ship'];
    } catch (e) { /* Balken bleibt, wie er ist */ }
  }

  function renderCart(cart, keepShip) {
    /* v1.92: Pop nur, wenn sich die Anzahl ändert und > 0 ist – sonst blinkte bei jedem Seitenaufruf ein leerer Kreis */
    cartCount.forEach((b) => { const prev = Number(b.dataset.count || 0); b.textContent = cart.item_count || ''; b.dataset.count = cart.item_count; if (cart.item_count > 0 && cart.item_count !== prev) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); } });
    if (!cartDrawer) return;
    const items = $('[data-cart-items]', cartDrawer), foot = $('[data-cart-foot]', cartDrawer);
    if (!keepShip) refreshShip();
    const total = cart.total_price || 0;
    if (!cart.items || !cart.items.length) {
      items.innerHTML = `<div class="cart__empty"><p class="h3">${escapeHtml(T('cart_empty_title', 'Noch leer.'))}</p><p>${escapeHtml(T('cart_empty_text', 'Vier Welten warten – Headshop, Growshop, Vaporizer und Outfit.'))}</p><button class="btn btn--ghost btn--sm" data-close>${escapeHtml(T('cart_empty_cta', 'Weiter stöbern'))}</button></div>`;
      foot.hidden = true; const nl0 = $('[data-cart-nl]', cartDrawer); if (nl0) nl0.hidden = true; return;
    }
    foot.hidden = false;
    const nl1 = $('[data-cart-nl]', cartDrawer); if (nl1) nl1.hidden = false;
    items.innerHTML = cart.items.map((it) => `
      <div class="ci" data-key="${escapeHtml(it.key)}">
        <a class="ci__img" href="${escapeHtml(it.url || '#')}" aria-label="${escapeHtml(it.product_title || it.title || '')}"><img src="${escapeHtml(it.image || '')}" alt="" loading="lazy" width="160" height="160"></a>
        <div class="ci__body">
          <span class="ci__vendor">${escapeHtml(it.vendor || '')}</span>
          <a class="ci__title" href="${escapeHtml(it.url || '#')}">${escapeHtml(it.product_title || it.title)}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<span class="ci__var">${escapeHtml(it.variant_title)}</span>` : ''}
          <div class="ci__row">
            <div class="qty"><button type="button" data-qty="-1" aria-label="${escapeHtml(T('qty_less', 'Weniger'))}">−</button><input type="number" value="${it.quantity}" min="0" aria-label="${escapeHtml(T('qty', 'Menge'))}" data-qty-input><button type="button" data-qty="1" aria-label="${escapeHtml(T('qty_more', 'Mehr'))}">+</button></div>
            <span class="price">${money(it.final_line_price != null ? it.final_line_price : it.line_price)}</span>
          </div>
          <button type="button" class="ci__rm" data-remove>${escapeHtml(T('remove', 'Entfernen'))}</button>
        </div>
      </div>`).join('');
    $('[data-cart-total]', cartDrawer).textContent = money(total);
  }

  /* v1.5: Nur die jeweils neueste Warenkorb-Abfrage darf zeichnen – eine ältere, langsamere Antwort
     (z. B. von vor dem Kauf-Klick) überschreibt sonst den neuen Stand. */
  let cartSeq = 0;
  function loadCart() {
    const n = ++cartSeq;
    return cartRequest(routes.get).then((c) => { if (n === cartSeq) renderCart(c); return c; });
  }

  async function changeLine(key, quantity) {
    try { const c = await cartRequest(routes.change, { id: key, quantity }); ++cartSeq; renderCart(c); } catch (e) { toast(e.message); }
  }
  cartDrawer && cartDrawer.addEventListener('click', (e) => {
    const line = e.target.closest('.ci'); if (!line) return;
    const key = line.dataset.key, input = $('[data-qty-input]', line);
    const q = e.target.closest('[data-qty]');
    if (q) { changeLine(key, Math.max(0, Number(input.value) + Number(q.dataset.qty))); }
    if (e.target.closest('[data-remove]')) changeLine(key, 0);
  });
  cartDrawer && cartDrawer.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]'); if (!input) return;
    changeLine(input.closest('.ci').dataset.key, Math.max(0, Number(input.value)));
  });

  /* ---------- „Im Warenkorb“-Fenster mit passenden Ergänzungen ---------- */
  const addedDlg = $('#added-dialog');
  const pdpEl = $('[data-product]');
  const pdpHandle = pdpEl ? pdpEl.dataset.handle : null;
  async function showAdded(item) {
    if (!addedDlg || !item) { openDialog('cart-drawer'); return; }
    const line = $('[data-added-line]', addedDlg), rail = $('[data-added-rail]', addedDlg), recs = $('[data-added-recs]', addedDlg);
    const price = item.final_price != null ? item.final_price : item.price;
    line.innerHTML = `<img src="${escapeHtml(item.image || '')}" alt="" width="96" height="96"><div><span class="ci__vendor">${escapeHtml(item.vendor || '')}</span><a class="ci__title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title || '')}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="ci__var">${escapeHtml(item.variant_title)}</span>` : ''}<span class="price">${money(price)}</span></div>`;
    rail.innerHTML = ''; recs.hidden = true;
    openDialog('added-dialog');
    let cards = [];
    const pageRail = $('[data-also-rail]');
    if (pageRail && pdpHandle && pdpHandle === item.handle) cards = $$(':scope > *', pageRail).map((c) => c.cloneNode(true));
    else if (item.handle) {
      try {
        const html = await (await fetch(`${R}products/${encodeURIComponent(item.handle)}?view=also`, { headers: { Accept: 'text/html' } })).text();
        cards = $$('.pc', new DOMParser().parseFromString(html, 'text/html'));
      } catch (e) {}
    }
    cards = cards.filter((c) => c.dataset.handle && c.dataset.handle !== item.handle).slice(0, 8);
    if (!cards.length || !addedDlg.open) return;
    cards.forEach((c) => rail.appendChild(c));
    recs.hidden = false;
    initRails(recs);
  }
  if (addedDlg) $('[data-added-cart]', addedDlg).addEventListener('click', () => { addedDlg.close(); openDialog('cart-drawer'); });

  async function addToCart(id, quantity, btn) {
    if (!id) return;
    btn && btn.classList.add('is-loading');
    const inAdded = !!(btn && addedDlg && addedDlg.contains(btn));
    try {
      const res = await cartRequest(routes.add, { items: [{ id: isNaN(Number(id)) ? id : Number(id), quantity: Number(quantity) || 1 }] });
      /* v1.5: erst den vollständigen Warenkorb laden und anzeigen, dann das Fenster öffnen – sonst sieht man bei
         schnellem Tippen auf „Zum Warenkorb“ noch den alten Stand und legt doppelt hinein. */
      try { await loadCart(); } catch (e) { refreshCart(); }
      const item = res && res.items ? res.items[0] : null;
      if (inAdded) {
        btn.classList.add('is-done');
        const s = btn.querySelector('span'); if (s) s.textContent = T('in_cart', 'Im Warenkorb ✓');
        toast(T('added', 'Dazugelegt.'));
      } else if (MOCK || !item) openDialog('cart-drawer');
      else showAdded(item);
    } catch (e) { toast(e.message || T('add_failed', 'Konnte nicht hinzugefügt werden.')); }
    finally { btn && btn.classList.remove('is-loading'); }
  }
  doc.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); e.stopPropagation(); if (!quick.classList.contains('is-loading')) addToCart(quick.dataset.quickAdd, 1, quick); }
  }, true);
  doc.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    const sub = form.querySelector('[type="submit"]');
    if (sub && sub.classList.contains('is-loading')) return;
    const id = form.querySelector('[name="id"]').value, qty = form.querySelector('[name="quantity"]');
    addToCart(id, qty ? qty.value : 1, sub);
  });
  if (cartDrawer) { const n0 = ++cartSeq; cartRequest(routes.get).then((c) => { if (n0 === cartSeq) renderCart(c, true); }).catch(() => {}); }
  /* v1.5: Warenkorb immer frisch – beim Öffnen des Drawers, nach „Zurück“ (Seite aus dem Browser-Cache) und beim
     Zurückkehren in den Tab (z. B. aus der Kasse oder einem zweiten Tab). */
  let cartFetch = null;
  function refreshCart() {
    if (MOCK) return Promise.resolve();
    if (!cartFetch) cartFetch = loadCart().catch(() => {}).finally(() => { cartFetch = null; });
    return cartFetch;
  }
  if (cartDrawer) {
    new MutationObserver(() => { if (cartDrawer.open) refreshCart(); }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
  }
  addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
  /* v1.51: Die Warenkorb-Seite selbst ist serverseitig gerendert – kommt sie per „Zurück/Vor“ aus dem Browser-Speicher,
     einmal frisch laden (danach ist der Navigationstyp „reload“, also keine Schleife). */
  if (/^\/cart\/?$/.test(location.pathname)) {
    const navE = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (navE && navE.type === 'back_forward') location.reload();
    addEventListener('pageshow', (e) => { if (e.persisted) location.reload(); });
  }
  doc.addEventListener('visibilitychange', () => { if (doc.visibilityState === 'visible') refreshCart(); });

  /* ---------- Produktseite: Varianten, Galerie, Sticky-Bar ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    let product = null;
    try { product = JSON.parse($('[data-product-json]', pdp).textContent); } catch (e) {}
    const form = $('form[data-product-form]', pdp);
    const idInput = form && form.querySelector('[name="id"]');
    const priceEl = $('[data-price]', pdp), compareEl = $('[data-compare]', pdp), savingEl = $('[data-saving]', pdp), availEl = $('[data-avail]', pdp), submit = form && form.querySelector('[type="submit"]');
    const gallery = $('.gallery__main', pdp);
    if (gallery) { const first = $('img', gallery); const loaded = () => gallery.classList.add('is-loaded'); if (first && first.complete && first.naturalWidth) loaded(); else if (first) first.addEventListener('load', loaded, { once: true }); }
    const baseOf = (u) => String(u || '').split('?')[0];
    const sized = (u, w) => { const clean = String(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return clean + (clean.includes('?') ? '&' : '?') + 'width=' + w; };
    let switching = null;
    /* Überblendung: das neue Bild lädt unsichtbar und blendet dann über das alte. srcset wird mitgezogen –
       nur src zu tauschen greift nicht, solange ein srcset am Bild hängt. */
    function switchImage(src) {
      if (!gallery || !src) return;
      const base = baseOf(src);
      const current = $('img:not(.is-out)', gallery);
      if (current && baseOf(current.currentSrc || current.src) === base) return;
      if (switching === base) return;
      switching = base;
      const img = new Image();
      img.alt = current ? current.alt : '';
      img.sizes = (current && current.sizes) || '(max-width: 980px) 100vw, 55vw';
      img.srcset = [600, 900, 1200, 1600].map((w) => sized(src, w) + ' ' + w + 'w').join(', ');
      img.decoding = 'async';
      img.className = 'is-in';
      img.onload = () => {
        if (switching !== base) return;
        gallery.appendChild(img); gallery.classList.add('is-loaded');
        requestAnimationFrame(() => requestAnimationFrame(() => img.classList.add('is-live')));
        $$('img', gallery).forEach((o) => { if (o !== img && !o.classList.contains('is-out')) { o.classList.add('is-out'); setTimeout(() => o.remove(), 750); } });
        switching = null;
      };
      img.onerror = () => { switching = null; };
      img.src = sized(src, 1200);
      $$('.gallery__thumbs button', pdp).forEach((b) => { if (baseOf(b.dataset.src) === base) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    }
    $$('.gallery__thumbs button', pdp).forEach((b) => b.addEventListener('click', () => switchImage(b.dataset.src)));

    function currentVariant() {
      if (!product) return null;
      const chosen = $$('.opt', pdp).map((o) => { const c = $('input:checked', o); return c ? c.value : null; });
      return product.variants.find((v) => v.options.every((val, i) => val === chosen[i])) || null;
    }
    function updateVariant() {
      const v = currentVariant(); if (!v) return;
      idInput && (idInput.value = v.id);
      priceEl && (priceEl.textContent = money(v.price));
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; compareEl.hidden = !(v.compare_at_price > v.price); }
      if (savingEl) { const s = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; savingEl.textContent = s ? `−${s} %` : ''; savingEl.hidden = !s; }
      priceEl && priceEl.classList.toggle('is-sale', v.compare_at_price > v.price);
      if (submit) { submit.disabled = !v.available; submit.querySelector('span').textContent = v.available ? T('add_to_cart', 'In den Warenkorb') : T('sold_out', 'Ausverkauft'); }
      if (availEl) { availEl.textContent = v.available ? (availEl.dataset.ok || T('delivery_default', '2–5 Werktage Lieferzeit')) : T('unavailable', 'Aktuell nicht verfügbar'); availEl.classList.toggle('is-ok', v.available); }
      // Ausverkauft: kein Express-Knopf, dafür „Benachrichtige mich“; Grundpreis je Variante
      const wallet = $('.buy__wallet', pdp); if (wallet) wallet.hidden = !v.available;
      const restock = $('[data-restock]', pdp); if (restock) { restock.hidden = !!v.available; const rv = $('[data-restock-variant]', restock); if (rv) rv.value = `${v.title || ''} · ${v.sku || ''}`; }
      const unit = $('[data-unit]', pdp); if (unit) { const m = v.unit_price_measurement; if (m && v.unit_price != null && m.reference_unit) { unit.textContent = `${money(v.unit_price)} / ${m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : ''}${m.reference_unit}`; unit.hidden = false; } else unit.hidden = true; }
      $$('.opt', pdp).forEach((o) => { const lbl = $('.opt__label b', o), c = $('input:checked', o); lbl && c && (lbl.textContent = c.value); });
      if (v.featured_image && v.featured_image.src) switchImage(v.featured_image.src);
      const sticky = $('.stickybuy .price'); sticky && (sticky.textContent = money(v.price));
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    pdp.addEventListener('change', (e) => { if (e.target.closest('.opt')) updateVariant(); });
    updateVariant();

    $$('.qty', pdp).forEach((q) => q.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]'); if (!b) return;
      const i = $('input', q); i.value = Math.max(1, Number(i.value) + Number(b.dataset.qty));
    }));

    const sticky = $('.stickybuy');
    if (sticky && submit) {
      new IntersectionObserver((en) => sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0), { threshold: 0 }).observe(submit);
      $('button', sticky) && $('button', sticky).addEventListener('click', () => form.requestSubmit());
    }
  }

  /* ---------- Kategorie: Sortierung, Filter, Mehr laden ---------- */
  const sortSel = $('[data-sort]');
  sortSel && sortSel.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page');
    if (MOCK) { toast(T('sort_prefix', 'Sortierung: ') + sortSel.options[sortSel.selectedIndex].text); return; }
    location.href = u.toString();
  });
  const filterForm = $('#filter-form');
  filterForm && filterForm.addEventListener('submit', (e) => {
    if (MOCK) { e.preventDefault(); filterForm.closest('dialog').close(); toast(T('filter_applied', 'Filter angewendet')); return; }
    // Leere Felder (Preis von/bis) nicht in die URL schreiben
    $$('input:not([type=checkbox]):not([type=radio]), select', filterForm).forEach((el) => { if (el.value === '') el.disabled = true; });
  });
  filterForm && addEventListener('pageshow', () => { $$('input:disabled, select:disabled', filterForm).forEach((el) => { el.disabled = false; }); });
  const more = $('[data-load-more]');
  if (more) {
    const grid = $('.pgrid');
    const sectionEl = grid && grid.closest('.shopify-section');
    const sid = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
    /* Nur die Produktliste nachladen (Section Rendering), nicht die ganze Seite: rund ein Fünftel der Daten. */
    const withSection = (u) => (sid ? u + (u.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sid) : u);
    let pending = null, pendingUrl = null;
    /* Die nächste Seite schon holen, sobald der Button in die Nähe rückt – der Klick fühlt sich dann sofort an. */
    function prefetch() {
      const url = more.dataset.loadMore;
      if (!url || MOCK || pendingUrl === url) return;
      pendingUrl = url;
      pending = fetch(withSection(url), { headers: { Accept: 'text/html' } }).then((r) => r.text()).catch(() => null);
    }
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => { if (en.some((e) => e.isIntersecting)) prefetch(); }, { rootMargin: '1600px 0px' }).observe(more);
    function updateCount() {
      const shown = $('[data-shown]'), track = $('.more .track i'), n = $$('.pgrid > *').length;
      if (shown) { shown.textContent = n; track && track.style.setProperty('--p', Math.min(100, n / Number(shown.dataset.total || 1) * 100) + '%'); }
    }
    function append(html) {
      const d = new DOMParser().parseFromString(html, 'text/html');
      const cards = $$('.pgrid > *', d);
      cards.forEach((n) => grid.appendChild(n));
      const nextBtn = $('[data-load-more]', d);
      if (nextBtn && nextBtn.dataset.loadMore) more.dataset.loadMore = nextBtn.dataset.loadMore;
      else { more.dataset.loadMore = ''; more.closest('.more').hidden = true; }
      observeReveals(grid);
      pending = null; pendingUrl = null;
      prefetch();
      return cards.length;
    }
    more.addEventListener('click', async () => {
      const url = more.dataset.loadMore; if (!url) return;
      more.classList.add('is-loading');
      try {
        if (MOCK) { await new Promise((r) => setTimeout(r, 500)); MOCK.loadMore(); }
        else {
          if (!pending || pendingUrl !== url) prefetch();
          const html = await pending;
          if (!html) throw new Error('leer');
          append(html);
        }
        updateCount();
      } catch (e) { pending = null; pendingUrl = null; toast(T('load_failed', 'Konnte nicht laden.')); }
      finally { more.classList.remove('is-loading'); }
    });
    /* v1.92: Geladene Artikel und Scrollposition merken – bei „Zurück“ vom Produkt dieselbe Stelle statt wieder 24 Artikel */
    const MKEY = 'osn_more:' + location.pathname + location.search;
    addEventListener('pagehide', () => { try { sessionStorage.setItem(MKEY, JSON.stringify({ n: $$('.pgrid > *').length, y: Math.round(scrollY) })); } catch (e) {} });
    (async () => {
      let st = null; try { st = JSON.parse(sessionStorage.getItem(MKEY) || 'null'); } catch (e) {}
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (MOCK || !st || !nav || nav.type !== 'back_forward' || st.n <= $$('.pgrid > *').length) return;
      for (let guard = 0; guard < 12 && $$('.pgrid > *').length < st.n && more.dataset.loadMore; guard++) {
        if (!pending || pendingUrl !== more.dataset.loadMore) prefetch();
        const html = await pending; if (!html) break;
        append(html); updateCount();
      }
      requestAnimationFrame(() => scrollTo(0, st.y));
    })();
  }

  /* ---------- Warenkorb-Seite: Mengen-Buttons + Auto-Update ---------- */
  const cartPageForm = $('.cartpage form');
  if (cartPageForm) {
    cartPageForm.addEventListener('click', (e) => {
      const b = e.target.closest('.qty [data-qty]'); if (!b) return;
      const i = b.parentElement.querySelector('input');
      i.value = Math.max(0, Number(i.value) + Number(b.dataset.qty));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    cartPageForm.addEventListener('change', (e) => { if (e.target.matches('input[name="updates[]"]')) cartPageForm.requestSubmit(); });
  }

  /* ---------- Öffnungszeiten (Hof): Wochenplan + Feiertage aus den Theme-Einstellungen, Uhrzeit Europe/Berlin ---------- */
  const HOURS_CFG = window.OSN_HOURS || {};
  const DAYS = T('days', 'So,Mo,Di,Mi,Do,Fr,Sa').split(',');
  const DAY_KEY = { so: 0, mo: 1, di: 2, mi: 3, do: 4, fr: 5, sa: 6 };
  const WEEK = { 0: null, 1: [600, 1140], 2: [600, 1140], 3: [600, 1140], 4: [600, 1140], 5: [600, 1140], 6: [600, 1080] };
  const toMin = (s) => { const m = /(\d{1,2})(?:[:.](\d{2}))?/.exec(s); return m ? Number(m[1]) * 60 + Number(m[2] || 0) : null; };
  const parseRange = (s) => {
    if (!s || /geschl|closed|\bzu\b/i.test(s)) return null;
    const m = /(\d{1,2}(?:[:.]\d{2})?)\s*(?:-|–|bis)\s*(\d{1,2}(?:[:.]\d{2})?)/.exec(s);
    return m ? [toMin(m[1]), toMin(m[2])] : null;
  };
  String(HOURS_CFG.week || '').split(/\r?\n|\|\|/).forEach((line) => {
    const m = /^\s*([a-zäöü]{2})\.?(?:\s*(?:-|–|bis)\s*([a-zäöü]{2})\.?)?\s+(.+)$/i.exec(line); if (!m) return;
    const a = DAY_KEY[m[1].toLowerCase()], b = m[2] ? DAY_KEY[m[2].toLowerCase()] : a; if (a === undefined || b === undefined) return;
    const r = parseRange(m[3]);
    for (let d = a, n = 0; n < 7; n++, d = (d + 1) % 7) { WEEK[d] = r; if (d === b) break; }
  });
  const addDays = (iso, n) => { const d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
  const normDate = (s) => { let m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s); if (m) return s; m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s); return m ? `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}` : null; };
  const SPECIAL = {};
  String(HOURS_CFG.special || '').split(/\r?\n/).forEach((line) => {
    const p = line.split('|').map((s) => s.trim()); if (!p[0] || p[0].startsWith('#')) return;
    const dm = /^(\S+)(?:\s*(?:\.\.|–|bis|-)\s*(\S+))?$/.exec(p[0]); if (!dm) return;
    const from = normDate(dm[1]), to = normDate(dm[2] || dm[1]); if (!from || !to) return;
    const hours = parseRange(p[1] || ''), label = p[2] || (hours ? T('h_special', 'Sonderöffnung') : T('h_holiday', 'Feiertag'));
    /* v1.92: Feiertage, die auf einen ohnehin geschlossenen Sonntag fallen, nicht anzeigen (Sonderöffnungen bleiben) */
    for (let iso = from, n = 0; n < 92 && iso <= to; n++, iso = addDays(iso, 1)) { if (!hours && !WEEK[0] && new Date(iso + 'T12:00:00Z').getUTCDay() === 0) continue; SPECIAL[iso] = { hours, label }; }
  });
  const nowBerlin = () => {
    try {
      const p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
      const iso = `${p.year}-${p.month}-${p.day}`;
      return { iso, day: new Date(iso + 'T12:00:00Z').getUTCDay(), mins: (Number(p.hour) % 24) * 60 + Number(p.minute) };
    } catch (e) {
      const d = new Date(), iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      return { iso, day: d.getDay(), mins: d.getHours() * 60 + d.getMinutes() };
    }
  };
  const dayInfo = (iso) => { const day = new Date(iso + 'T12:00:00Z').getUTCDay(), sp = SPECIAL[iso]; return { iso, day, hours: sp ? sp.hours : WEEK[day], label: sp ? sp.label : '' }; };
  const fmt = (m) => {
    if (LANG === 'en') { const hh = Math.floor(m / 60), h12 = hh % 12 || 12, mm = m % 60; return `${h12}${mm ? ':' + String(mm).padStart(2, '0') : ''} ${hh < 12 ? 'am' : 'pm'}`; }
    return (m % 60 ? `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}` : String(m / 60)) + ' Uhr';
  };
  const fmtCell = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
  const dShort = (iso) => `${Number(iso.slice(8, 10))}.${Number(iso.slice(5, 7))}.`;
  function storeStatus(now) {
    const t = dayInfo(now.iso), pre = t.label ? `${t.label} · ` : '';
    if (t.hours && now.mins >= t.hours[0] && now.mins < t.hours[1]) {
      return { open: true, text: `${pre}${t.hours[1] - now.mins <= 45 ? T('h_closing_soon', 'Schließt bald') : T('h_open_now', 'Jetzt geöffnet')} · ${T('h_until', 'bis {time}', { time: fmt(t.hours[1]) })}` };
    }
    if (t.hours && now.mins < t.hours[0]) return { open: false, text: `${pre}${pre ? T('h_opens_today_lc', 'öffnet heute {time}', { time: fmt(t.hours[0]) }) : T('h_opens_today', 'Öffnet heute {time}', { time: fmt(t.hours[0]) })}` };
    for (let i = 1; i <= 21; i++) {
      const n = dayInfo(addDays(now.iso, i)); if (!n.hours) continue;
      const when = i === 1 ? T('h_tomorrow', 'morgen') : (i < 7 ? DAYS[n.day] : `${DAYS[n.day]} ${dShort(n.iso)}`);
      return { open: false, text: pre ? `${pre}${T('h_closed_opens', 'geschlossen · öffnet {when} {time}', { when, time: fmt(n.hours[0]) })}` : T('h_closed_now_opens', 'Derzeit geschlossen · öffnet {when} {time}', { when, time: fmt(n.hours[0]) }) };
    }
    return { open: false, text: `${pre}${T('h_closed_now', 'Derzeit geschlossen')}` };
  }
  function updateHours() {
    const now = nowBerlin(), st = storeStatus(now), todaySpecial = !!SPECIAL[now.iso];
    $$('.hours').forEach((t) => {
      $$('tr.hours__special', t).forEach((r) => r.remove());
      $$('tr[data-day]', t).forEach((tr) => tr.classList.toggle('is-today', !todaySpecial && Number(tr.dataset.day) === now.day));
      const rows = [];
      for (let i = 0; i <= 28 && rows.length < 3; i++) {
        const iso = addDays(now.iso, i), sp = SPECIAL[iso]; if (!sp) continue;
        rows.push(`<tr class="hours__special${i === 0 ? ' is-today' : ''}"><th>${DAYS[dayInfo(iso).day]} ${dShort(iso)} · ${escapeHtml(sp.label)}</th><td>${sp.hours ? `${fmtCell(sp.hours[0])} – ${fmtCell(sp.hours[1])}` : escapeHtml(T('h_closed', 'geschlossen'))}</td></tr>`);
      }
      if (rows.length) t.insertAdjacentHTML('beforeend', rows.join(''));
    });
    $$('[data-store-status]').forEach((box) => {
      const label = $('b', box); if (!label) return;
      box.classList.toggle('is-open', st.open); box.classList.toggle('is-closed', !st.open);
      label.textContent = st.text;
    });
  }
  updateHours(); setInterval(updateHours, 60000);

  /* ---------- v1.6: Newsletter-Anmeldung im Warenkorb ----------
     Feld und Knopf hängen per form="…" an einem leeren Kundenformular außerhalb des Kassen-Formulars.
     Abschicken per fetch, Bestätigung an Ort und Stelle; verlangt Shopify ein Captcha (/challenge), normal absenden. */
  const NL_KEY = 'osn_nl_ok';
  let nlDone = false;
  try { nlDone = !!localStorage.getItem(NL_KEY); } catch (e) {}
  $$('[data-nl-cart]').forEach((box) => {
    const form = doc.getElementById(box.dataset.nlCart);
    if (!form) return;
    if (nlDone) { box.hidden = true; return; }
    const row = $('[data-nl-row]', box), msg = $('[data-nl-msg]', box), btn = $('button', box), input = $('input[type="email"]', box);
    const say = (text, cls) => { msg.textContent = text; msg.className = 'cnl__msg' + (cls ? ' ' + cls : ''); msg.hidden = false; };
    if (/[?&]customer_posted=true/.test(location.search)) { row.hidden = true; say(T('nl_ok', 'Danke – bitte bestätige die E-Mail, die wir dir gerade geschickt haben.'), 'is-ok'); }
    form.addEventListener('submit', async (e) => {
      if (MOCK) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      if (input && !input.checkValidity()) { input.reportValidity(); return; }
      btn.classList.add('is-loading');
      try {
        const r = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (/\/challenge/.test(r.url)) { HTMLFormElement.prototype.submit.call(form); return; }
        if (r.ok && /customer_posted=true/.test(r.url)) {
          row.hidden = true;
          say(T('nl_ok', 'Danke – bitte bestätige die E-Mail, die wir dir gerade geschickt haben.'), 'is-ok');
          try { localStorage.setItem(NL_KEY, String(Date.now())); } catch (x) {}
        } else {
          say(T('nl_bad', 'Das hat nicht geklappt – bitte prüfe die E-Mail-Adresse.'), 'is-err');
        }
      } catch (err) {
        say(T('nl_offline', 'Gerade keine Verbindung – bitte versuch es gleich noch einmal.'), 'is-err');
      } finally { btn.classList.remove('is-loading'); }
    });
  });

  /* ---------- Newsletter im Prototyp ---------- */
  $$('form[data-newsletter]').forEach((f) => f.addEventListener('submit', (e) => {
    if (!MOCK) return; e.preventDefault(); toast(T('nl_mock', 'Danke – bitte E-Mail bestätigen.')); f.reset();
  }));

  /* ---------- nova: Gespräch als Chat – Begrüßung, Beispielfragen als Chips (anklickbar), Antworten als Schreibmaschine ---------- */
  const chat = $('[data-nova-chat]');
  if (chat) {
    let pairs = [];
    try { pairs = JSON.parse(chat.dataset.pairs || '[]'); } catch (e) {}
    pairs = pairs.filter((p) => p && p.q && p.a);
    const greeting = chat.dataset.greeting || '';
    const qEl = $('[data-nova-q]', chat), aEl = $('[data-nova-a]', chat), qWrap = $('[data-nova-qwrap]', chat);
    const chips = $$('[data-nova-chip]', chat);
    const setChip = (i) => chips.forEach((c, n) => c.classList.toggle('is-on', n === i));
    /* v1.56: Die Chat-Fläche reserviert die Höhe der längsten Frage-Antwort – sonst wächst und schrumpft sie beim
       Tippen und schiebt die Seite darunter mit. Gemessen wird unsichtbar im selben Frame, neu bei Breitenänderung. */
    const stream = $('.nova__stream', chat);
    const reserveChat = () => {
      if (!stream || !qEl || !aEl || !qWrap) return;
      const keep = [qEl.textContent, aEl.textContent, qWrap.hidden, chat.className];
      stream.style.minHeight = '';
      chat.classList.remove('is-typing'); chat.classList.add('is-answering');
      let max = 0;
      const sets = pairs.map((p) => [p.q, p.a]); if (greeting) sets.push(['', greeting]);
      sets.forEach(([q, a]) => { qWrap.hidden = !q; qEl.textContent = q; aEl.textContent = a; max = Math.max(max, stream.offsetHeight); });
      qEl.textContent = keep[0]; aEl.textContent = keep[1]; qWrap.hidden = keep[2]; chat.className = keep[3];
      if (max) stream.style.minHeight = Math.ceil(max) + 'px';
    };
    reserveChat();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(reserveChat);
    let chatW = chat.clientWidth, chatT = 0;
    addEventListener('resize', () => { clearTimeout(chatT); chatT = setTimeout(() => { if (chat.clientWidth !== chatW) { chatW = chat.clientWidth; reserveChat(); } }, 150); });
    if (qEl && aEl && qWrap && (pairs.length || greeting)) {
      if (reduced) {
        const show = (n) => { const p = pairs[n]; if (!p) return; qEl.textContent = p.q; aEl.textContent = p.a; qWrap.hidden = false; setChip(n); };
        if (pairs.length) show(0); else { aEl.textContent = greeting; qWrap.hidden = true; }
        chat.classList.add('is-answering', 'is-done');
        chips.forEach((c, n) => c.addEventListener('click', () => show(n)));
      } else {
        let token = 0, started = false;
        const cancel = new Error('cancel');
        const wait = (ms, tk) => new Promise((r) => setTimeout(r, ms)).then(() => { if (tk !== token) throw cancel; });
        const type = (el, text, speed, tk) => new Promise((res, rej) => {
          let n = 0; el.textContent = '';
          const t = setInterval(() => {
            if (tk !== token) { clearInterval(t); rej(cancel); return; }
            el.textContent = text.slice(0, ++n); if (n >= text.length) { clearInterval(t); res(); }
          }, speed);
        });
        async function say(text, tk, delay) {
          chat.classList.remove('is-answering'); aEl.textContent = '';
          chat.classList.add('is-typing'); await wait(delay, tk);
          chat.classList.remove('is-typing'); chat.classList.add('is-answering');
          await type(aEl, text, 22, tk);
        }
        async function play(idx, tk) {
          const p = pairs[idx % pairs.length];
          setChip(idx % pairs.length);
          chat.classList.remove('is-answering'); aEl.textContent = ''; qWrap.hidden = false;
          await type(qEl, p.q, 36, tk); await wait(380, tk);
          await say(p.a, tk, 900); await wait(5200, tk);
        }
        async function loop(startIdx) {
          const tk = ++token;
          try {
            if (startIdx == null && greeting) { qWrap.hidden = true; qEl.textContent = ''; setChip(-1); await say(greeting, tk, 700); await wait(3000, tk); }
            if (!pairs.length) return;
            for (let idx = startIdx == null ? 0 : startIdx; ; idx++) await play(idx, tk);
          } catch (e) { if (e !== cancel) throw e; }
        }
        chips.forEach((c, n) => c.addEventListener('click', () => { started = true; loop(n); }));
        const start = () => { if (started) return; started = true; loop(null); };
        if ('IntersectionObserver' in window) new IntersectionObserver((en, io) => { if (en.some((e) => e.isIntersecting)) { start(); io.disconnect(); } }, { rootMargin: '0px 0px -10% 0px' }).observe(chat);
        else start();
      }
    }
  }

  /* ---------- Mega-Menü (Maus): öffnet beim Überfahren, schließt erst mit Verzögerung – die Diagonale ins Panel bleibt möglich ---------- */
  if (fine) {
    const navItems = $$('.head__nav > li');
    let closeT = 0, openT = 0, current = null;
    const openMega = (li) => { navItems.forEach((x) => x.classList.toggle('is-open', x === li)); current = li; };
    const closeMega = () => { navItems.forEach((x) => x.classList.remove('is-open')); current = null; };
    navItems.forEach((li) => {
      const hasMega = !!$('.mega', li);
      li.addEventListener('pointerenter', () => {
        clearTimeout(closeT); clearTimeout(openT);
        if (hasMega) openT = setTimeout(() => openMega(li), current ? 60 : 120);
        else closeT = setTimeout(closeMega, 160);
      });
      li.addEventListener('pointerleave', () => { clearTimeout(openT); closeT = setTimeout(closeMega, 420); });
    });
    if (head) head.addEventListener('pointerleave', () => { clearTimeout(openT); closeT = setTimeout(closeMega, 320); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMega(); });
    document.addEventListener('click', (e) => { if (current && !e.target.closest('.head__nav')) closeMega(); });
  }

  /* ---------- Versprechen als Fünfeck (Handy): Knoten antippen; rotiert von selbst, bis jemand tippt ---------- */
  $$('[data-usp]').forEach((stage) => {
    const items = $$('.usp > li', stage), detail = stage.parentElement.querySelector('[data-usp-detail]'), center = $('.usp__center', stage);
    if (!items.length || !detail) return;
    const mq = matchMedia('(max-width: 900px)');
    let idx = 0, timer = 0, touched = false;
    const show = (n) => {
      idx = (n + items.length) % items.length;
      items.forEach((li, k) => { const on = k === idx; li.classList.toggle('is-on', on); const b = $('.usp__node', li); if (b) b.setAttribute('aria-pressed', String(on)); });
      const li = items[idx], text = $('.usp__text', li), svg = $('.usp__node svg', li);
      detail.classList.remove('is-swap'); void detail.offsetWidth; detail.classList.add('is-swap');
      detail.innerHTML = text ? text.innerHTML : '';
      if (center) {
        center.innerHTML = ''; if (svg) center.appendChild(svg.cloneNode(true));
        const short = $('.usp__short', li); if (short) { const b = doc.createElement('b'); b.className = 'usp__center-lbl'; b.textContent = short.textContent; center.appendChild(b); }
      }
    };
    const stop = () => { clearInterval(timer); timer = 0; };
    const start = () => { if (!timer && mq.matches && !touched && !reduced) timer = setInterval(() => show(idx + 1), 3600); };
    // iOS Safari: Klick direkt am Knopf abgreifen, dazu pointerup bei Touch als Rückfall (Klicks in transformierten Ebenen gehen dort gern verloren)
    items.forEach((li, k) => {
      const btn = $('.usp__node', li); if (!btn) return;
      let lastTap = 0;
      const pick = (e) => { if (!mq.matches) return; const now = Date.now(); if (now - lastTap < 500) return; lastTap = now; touched = true; stop(); show(k); if (e.cancelable) e.preventDefault(); };
      btn.addEventListener('click', pick);
      btn.addEventListener('pointerup', (e) => { if (e.pointerType === 'touch' || e.pointerType === 'pen') pick(e); });
    });
    show(0);
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) start(); else stop(); }, { threshold: 0.3 }).observe(stage);
    else start();
    mq.addEventListener('change', () => { if (!mq.matches) stop(); else start(); });
  });

  /* ---------- Dunkle Produktfotos: heller Rahmen wird schwarz (Karten, Galerie, Thumbnails) ----------
     Ein 24-px-Abzug des Bildes wird mit CORS geladen und am Rand vermessen; das Ergebnis liegt je Bild in sessionStorage. */
  const darkCache = (() => { try { return JSON.parse(sessionStorage.getItem('osn.dark') || '{}'); } catch (e) { return {}; } })();
  const darkSave = () => { try { sessionStorage.setItem('osn.dark', JSON.stringify(darkCache)); } catch (e) { /* egal */ } };
  const tiny = (u) => { const clean = String(u).split('#')[0].replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return clean + (clean.includes('?') ? '&' : '?') + 'width=24'; };
  function markDark(img, box) {
    if (!img || !box || box.dataset.dark) return;
    const src = img.currentSrc || img.src; if (!src || !/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return;
    const key = src.split('?')[0].slice(-80);
    box.dataset.dark = 'pending';
    if (key in darkCache) { box.dataset.dark = darkCache[key] ? '1' : '0'; box.classList.toggle('is-dark', !!darkCache[key]); return; }
    const probe = new Image(); probe.crossOrigin = 'anonymous'; probe.decoding = 'async';
    probe.onload = () => {
      let dark = false;
      try {
        const c = doc.createElement('canvas'); c.width = 24; c.height = 24;
        const g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(probe, 0, 0, 24, 24);
        const d = g.getImageData(0, 0, 24, 24).data; let sum = 0, n = 0;
        for (let y = 0; y < 24; y++) for (let x = 0; x < 24; x++) {
          if (y > 2 && y < 21 && x > 2 && x < 21) continue;
          const i = (y * 24 + x) * 4; if (d[i + 3] < 200) continue;
          sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++;
        }
        dark = n > 60 && sum / n < 60;
      } catch (e) { dark = false; }
      darkCache[key] = dark ? 1 : 0; darkSave();
      box.dataset.dark = dark ? '1' : '0'; box.classList.toggle('is-dark', dark);
    };
    probe.onerror = () => { box.dataset.dark = '0'; };
    probe.src = tiny(src);
  }
  function initDark(scope) {
    $$('.pc__media > img, .gallery__main > img, .gallery__thumbs button > img', scope).forEach((img) => {
      const box = img.closest('.pc__media, .gallery__main, .gallery__thumbs button');
      const go = () => markDark(img, box);
      if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
    });
  }
  initDark(doc);
  if ('MutationObserver' in window) new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) initDark(n); }))).observe(doc.body, { childList: true, subtree: true });

  /* ---------- Suchseite: „Meintest du …?“ bei Umlaut-Umschreibung ---------- */
  const altEl = $('[data-search-alt]');
  if (altEl) {
    const q = new URLSearchParams(location.search).get('q') || '';
    const alt = umlaut(q);
    const count = async (term) => { const r = await fetch(`${routes.suggest}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10`); const j = await r.json(); return (j.resources && j.resources.results && j.resources.results.products || []).length; };
    if (alt !== q) Promise.all([count(q), count(alt)]).then(([a, b]) => { if (b > a) { altEl.innerHTML = escapeHtml(T('did_you_mean', 'Meintest du {link}?')).replace('{link}', `<a href="${R}search?q=${encodeURIComponent(alt)}">„${escapeHtml(alt)}“</a>`); altEl.hidden = false; } }).catch(() => {});
  }

  /* ---------- Produkt-Chips: führende Emoji-Platzhalter aus den Metafeld-Texten entfernen (v1.31) ---------- */
  $$('.chips li').forEach((li) => {
    const raw = li.textContent.trim();
    let clean = raw;
    try { clean = raw.replace(/^[\s\p{Extended_Pictographic}\p{Emoji_Presentation}️‍⃣ℹ⏹▪-◾⬛⬜⭐✅❌]+/u, '').trim(); } catch (e) { clean = raw.replace(/^[\sℹ⏹️\uD83C-􏰀-\uDFFF]+/, '').trim(); }
    if (clean && clean !== raw) li.textContent = clean;
  });

  /* ---------- Jahr ---------- */
  $$('[data-year]').forEach((y) => (y.textContent = new Date().getFullYear()));

  /* ---------- v1.53: Google-Bewertungen (Appio) barrierearm ----------
     Sterne sind Schriftzeichen (¡/¢) aus einem Symbol-Font – für Screenreader ausblenden und „n von 5 Sternen“ ansagen;
     englische Karussell-Beschriftungen von Swiper ins Deutsche. */
  const agrsFix = (root) => {
    $$('.agrs__rating-stars', root).forEach((s) => {
      if (s.dataset.a11y) return;
      const all = $$('.agrs__rating-star', s);
      if (!all.length) return;
      s.dataset.a11y = '1';
      const n = all.filter((i) => i.hasAttribute('solid')).length || all.length;
      s.setAttribute('role', 'img');
      s.setAttribute('aria-label', T('stars', '{n} von 5 Sternen', { n }));
      all.forEach((i) => i.setAttribute('aria-hidden', 'true'));
    });
    $$('[aria-label]', root).forEach((b) => {
      const l = b.getAttribute('aria-label'); let m;
      if (l === 'Previous slide') b.setAttribute('aria-label', T('rev_prev', 'Vorherige Bewertung'));
      else if (l === 'Next slide') b.setAttribute('aria-label', T('rev_next', 'Nächste Bewertung'));
      else if ((m = /^Go to slide (\d+)$/.exec(l))) b.setAttribute('aria-label', T('rev_goto', 'Zu Bewertung {n}', { n: m[1] }));
      else if ((m = /^(\d+) \/ (\d+)$/.exec(l))) b.setAttribute('aria-label', T('rev_of', 'Bewertung {n} von {total}', { n: m[1], total: m[2] }));
    });
  };
  $$('.apps').forEach((box) => {
    let t = null;
    const run = () => { clearTimeout(t); t = setTimeout(() => agrsFix(box), 120); };
    /* Swiper setzt die Beschriftungen bei jedem Bildwechsel neu (Attribut) – deshalb auch aria-label beobachten;
       deutsche Werte passen auf kein Muster mehr, also keine Schleife. */
    new MutationObserver(run).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    run();
  });

  window.OSN = { addToCart, renderCart, toast, initRails, observeReveals, openDialog, money };

  /* ---------- v1.43: in der Ladephase vorgemerkte Kauf-Klicks abarbeiten ---------- */
  (window.OSN_Q || []).splice(0).forEach((x) => {
    if (x.tagName === 'FORM') {
      const qty = x.querySelector('[name="quantity"]');
      addToCart(x.querySelector('[name="id"]').value, qty ? qty.value : 1, x.querySelector('[type="submit"]'));
    } else addToCart(x.dataset.quickAdd, 1, x);
  });
})();
